import React from 'react';
import PropTypes from 'prop-types';
import BasicFormField from '../../../common/formFields/basicFormField';
import CheckboxSwitch from '../../../common/checkboxSwitch';
import SimpleCheckbox from '../../../common/simpleCheckbox';

const BarberUsername = ({ disableUsername, onPopulateUsernameChange, userEnabled, isBarberUser }) => (
  <React.Fragment>
    <div className="layout__item" display-if={!isBarberUser}>
      <SimpleCheckbox
        name="userEnabled"
        id="userEnabled"
        label="Enable username"
      />
    </div>
    <div className="layout__item u-1/2-medium-and-up" display-if={userEnabled}>
      <BasicFormField
        label="Username"
        name="username"
        placeholder="Barber username"
        disabled={disableUsername}
        wrapperClass=""
        type="email"
      />
    </div>
    <div className="layout__item u-1/2-medium-and-up medium-and-up-mt-" display-if={userEnabled}>
      <CheckboxSwitch
        name="populateUsername"
        id="populateUsername"
        label="Populate username from email instead"
        wrapperClass="u-mt--"
        onChange={onPopulateUsernameChange}
      />
    </div>
  </React.Fragment>
);

BarberUsername.propTypes = {
  disableUsername: PropTypes.bool,
  userEnabled: PropTypes.bool,
  onPopulateUsernameChange: PropTypes.func.isRequired,
  isBarberUser: PropTypes.bool,
};

BarberUsername.defaultProps = {
  disableUsername: false,
  userEnabled: false,
  isBarberUser: false,
};

export default BarberUsername;
